import React from "react";
import { Panel, PanelBody, PanelHeader } from "../../../components/panel/panel";
import { Link, useNavigate } from 'react-router-dom';

// import {
//   checkConfiguration,
//   uploadConfiguration,
// } from "../../../services/StampService";
import { useFormik } from "formik";
import ConfigBillingForm from "../../../forms/ConfigBillingForm";
import CSDForm from "../../../forms/CSDForm";
import { getConfigBillSchema } from "../../../validations/ConfigBillSchema";
import {
    ConfigBillFilled,
    InitialConfigBill,
} from "../../../models/ConfigBill";
import notification from '../../../components/Notification';

import { updateocialReason } from "../../../services//CatalogService";
import { getMySocialReasons } from "../../../services//CatalogService";
import { getFileLogo } from "../../../services//CatalogService";
import { uploadCer } from "../../../services//CatalogService";

import Loader from "../../../components/loader/index";
import { formatDate } from "../../../utils";
import Swal from 'sweetalert2';

const ConfigBilling = () => {
    const razonSocial = 'GruasVaro';
    const [loading, setLoading] = React.useState(false);
    const [initialValues, setInitialValues] = React.useState(InitialConfigBill);
    const [bloqued, setBloqued] = React.useState(false);
    const [csd, setScd] = React.useState({
        key: null,
        cer: null,
    });

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: getConfigBillSchema(),
        initialValues: initialValues,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                
                const {  id, rfc, name, description, fiscalRegimeId, logoUrl, postalCode, primaryColor} = values;
                const payload = {
                    id,
                    rfc,
                    name,
                    description,
                    fiscalRegimeId: fiscalRegimeId.id, 
                    logoId: logoUrl?.id || null,
                    razonSocial,
                    postalCode,
                    primaryColor 
                };
                //console.log("test enviados", payload);
                await updateocialReason(payload);
                
                const hasCer = !!csd.cer;
                const hasKey = !!csd.key;
                const hasPassword = !!values.csdPassword;
                const backendPassword = initialValues?.csdPassword;

                // Validación: Si cambia la contraseña y el backend tiene una establecida
                if (
                    backendPassword && 
                    backendPassword !== values.csdPassword &&
                    (!hasCer || !hasKey)
                ) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error de configuración',
                        text: 'Para actualizar la contraseña es necesario subir también la Clave privada y Certificado público.'
                    });
                    return;
                }

                // Validación: Si se sube solo un archivo o falta la contraseña
                if ((hasCer || hasKey) && (!hasCer || !hasKey || !hasPassword)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error de configuración',
                        text: 'Para actualizar los certificados es necesario subir ambos archivos y una contraseña válida.'
                    });
                    return;
                }
    
        
                 if (csd.cer && csd.key && values.csdPassword) {
                    try {
                        await uploadCer({
                        cer: csd.cer,
                        key: csd.key,
                        csdPassword: values.csdPassword,
                        razonSocial
                        });
                    } catch (uploadError) {
                        const data = uploadError?.response?.data;
                        const detail = data?.messageDetail || data?.message || "Error al subir certificados";
                        notification("error", "Certificados: "+detail);
                        return; 
                    }
                        } else {
                        console.warn("Faltan archivos o la contraseña del CSD.");
                    }

                // Save apiKey && id
                notification("success", "Configuración guardada correctamente", "");
            } catch (error) {
                console.log(error);
                const errorMessage = error?.response?.data?.message || "Ocurrió un error inesperado";
                notification("error", errorMessage, "");
            } finally {
                setLoading(false);
            }
        },
    });

    const verifyConfiguration = async () => {
      try {
        const response = await getMySocialReasons(razonSocial);

        // Validar que response tenga contenido
        if (response && response.id) {
            // Obtener logo si existe
            if (response.logo && response.logo.id) {
                const logoUrl = await getFileLogo(response.logo.id);
                response.logoUrl = logoUrl;
            }

            setInitialValues({
                ...ConfigBillFilled(response),
                id: response.id
            });
        }
    } catch (error) {
        const errorMessage = error?.response?.data?.message || "Ocurrió un error inesperado";
        notification("warning", errorMessage, "");

        if (error?.message === "Error de conexión con el servidor.") {
            setBloqued(true);
        }

        console.log(error);
    }
    };    

    React.useEffect(() => {
        verifyConfiguration();
    }, []);

    return (
        <React.Fragment>
            <Loader isLoading={loading} />
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        {/* <li className="breadcrumb-item"><Link to="/catalogs/roadsideAssistances">Asistencias viales</Link></li> */}
                    </ol>
                    <h1 className="page-header mb-0">Configurar facturación</h1>
                </div>
            </div>



            {bloqued ? (
                <div class="alert alert-warning" role="alert">
                    Ah ocurrido un error al cargar la configuración, por favor intentalo
                    más tarde.
                </div>
            ) : (
                <>
                    <div className="row mb-3">
                        <div className="col-xl-12">
                            {initialValues?.updatedAt && (
                                <div class="alert alert-info" role="alert">
                                    Ultima actualización: {formatDate(initialValues.updatedAt)}
                                </div>
                            )}

                            <ConfigBillingForm formik={formik} />
                            <CSDForm csd={csd} setScd={(e) => setScd(e)} formik={formik} />
                        </div>
                    </div>

                    <div className="d-flex justify-content-end align-items-end">
                        <button
                            className="btn btn-primary p-3 fs-15px"
                            type="submit"
                            
                            onClick={() => {
                                console.log('Formik errors:', formik.errors);
                                formik.handleSubmit();
                              }}
                        >
                            <i className="fa-solid fa-floppy-disk" />
                            &nbsp;&nbsp;Guardar
                        </button>
                    </div>
                </>
            )}
        </React.Fragment>
    );
};

export default ConfigBilling;